import PropTypes from 'prop-types';
import React, { memo, useEffect } from 'react';
import { Map, List } from 'immutable';
import { connect } from 'react-redux';

import connectOptions, { mergeProps } from '../../../utils/connectOptions';
import config from '../../../config';
import Popups from '../../../components/Popup';
import {
  savePopup,
  selectSuggestion,
  reset,
  changeText,
  loadSuggestion,
  changeMode,
  setError,
  setWarning,
} from '../../../actions/nextAction/flipPopup';
import { usePopupContext } from '../../../contexts/PopupContext';

const InternalFlipPopupContainer = props => {
  const { closePopup } = usePopupContext();
  const {
    popup,
    module,
    associate,
    dealmaker,
    idList,
    savePopup,
    reset,
    changeText,
    loadSuggestion,
    selectSuggestion,
    setError,
    setWarning,
    changeMode,
  } = props;

  useEffect(
    () => () => {
      reset();
    },
    [reset],
  );

  const validate = () => {
    if (!module.get('id') || module.get('id') <= 0) {
      setError(['Missing Module!']);

      return false;
    }

    return true;
  };

  const handleSave = () => {
    const refreshGrid = popup.getIn(['props', 'refreshGrid'], () => {});
    const hash = popup.getIn(['props', 'hash']);

    if (validate()) {
      savePopup(hash, module.get('id'), associate.get('id'), dealmaker.get('id'), idList.toArray(), () => {
        refreshGrid();
        closePopup();
      });
    }
  };

  const handleInputChange = ({ event }) => {
    const { name, value = '' } = event.target;

    changeText(name, value);
    loadSuggestion(name, value);
    setError([]); // Clear error
    if (name === 'module' && !value) {
      setWarning('associate', '');
      setWarning('dealmaker', '');
    } else if (name !== 'module' && module.get('value')) {
      if (name === 'associate' && !value) {
        setWarning('associate', 'Secondary DM /Analyst/Assoc. will be emptied');
      }

      if (name === 'dealmaker' && !value) {
        setWarning('dealmaker', '3rd DM / Analyst will be cleared/emptied');
      }
    }
  };

  const handleSuggestionClose = ({ event }) => {
    changeMode(event.target.name, config.VIEW_MODE);
  };

  const handleSuggestionSelect = ({ event, suggestion }) => {
    const { name } = event.target;

    selectSuggestion(suggestion.get('id'), name, suggestion.get('name'));
    if (name === 'module') {
      if (!associate.get('id')) {
        setWarning('associate', 'Secondary DM /Analyst/Assoc. will be emptied');
      }

      if (!dealmaker.get('id')) {
        setWarning('dealmaker', '3rd DM / Analyst will be cleared/emptied');
      }
    } else if ((name === 'associate' || name === 'dealmaker') && suggestion.get('id') > 0) {
      setWarning(name, '');
    }
  };

  return (
    <Popups.InternalFlipPopup
      {...props}
      onClose={closePopup}
      onInputChange={handleInputChange}
      onSave={handleSave}
      onSuggestionClose={handleSuggestionClose}
      onSuggestionSelect={handleSuggestionSelect}
    />
  );
};

InternalFlipPopupContainer.propTypes = {
  associate: PropTypes.instanceOf(Map).isRequired,
  dealmaker: PropTypes.instanceOf(Map).isRequired,
  errors: PropTypes.instanceOf(List).isRequired,
  module: PropTypes.instanceOf(Map).isRequired,
  suggestions: PropTypes.instanceOf(List).isRequired,
};

function mapStateToProps(state, props) {
  const popup = state.nextAction.flipPopup;
  const idList = props.popup.getIn(['props', 'idList']);

  return {
    idList,
    associateWarning: popup.get('associateWarning'),
    dealmakerWarning: popup.get('dealmakerWarning'),
    waiting: popup.get('waiting'),
    errors: popup.get('errors'),
    suggestions: popup.get('suggestions'),
    module: popup.get('module'),
    associate: popup.get('associate'),
    dealmaker: popup.get('dealmaker'),
  };
}

const InternalFlipPopupContainerMemo = memo(InternalFlipPopupContainer);

export { InternalFlipPopupContainerMemo as InternalFlipPopupContainer };
export default connect(
  mapStateToProps,
  {
    savePopup,
    selectSuggestion,
    reset,
    changeText,
    loadSuggestion,
    changeMode,
    setError,
    setWarning,
  },
  mergeProps,
  connectOptions,
)(InternalFlipPopupContainerMemo);
